import { BookingAddOnsCancelResponseDto } from '@hqo/resource-booking-client';

/* The service splits a permanent refusal (409) from a transient one (503); collapsing them strands
 * the tenant on either a retry that is always refused or a dead end that would have worked. */

export interface AddOnCancelled {
  kind: 'cancelled';
  /* Empty is a no-op, not a failure: a booking with no live add-on order answers 200 with nothing listed. */
  vendorCompanyUuids: string[];
}

export type AddOnCancelOutcome =
  | AddOnCancelled
  /** 409 — permanent. Pressing again cannot change it; the tenant needs the sentence, not the button. */
  | { kind: 'refused' }
  /** 503 — transient. The order is still being created, or a Service Request could not be read. */
  | { kind: 'unavailable' }
  | { kind: 'failed' };

export type AddOnCancelFailure = Exclude<AddOnCancelOutcome, AddOnCancelled>['kind'];

/* Keyed on the HTTP status, not the error body: the generated client throws the parsed body and never
 * the Response, so the caller captures the real status and passes it here. `null` means none arrived. */
export const addOnCancelFailure = (status: number | null): AddOnCancelFailure => {
  if (status === 409) {
    return 'refused';
  }

  if (status === 503) {
    return 'unavailable';
  }

  return 'failed';
};

/** The success shape, read off the wire. The field is declared required; a missing one is still empty. */
export const addOnCancelled = ({ cancelledVendorCompanyUuids }: BookingAddOnsCancelResponseDto): AddOnCancelled => ({
  kind: 'cancelled',
  vendorCompanyUuids: cancelledVendorCompanyUuids ?? [],
});
